export default function getConfig() {
     //return "http://127.0.0.1:8081/api/"
     return "https://www.ildkule.net/api/"

    
}
